export const msalConfig = {
  auth: {
    clientId: "dd851f92-a1dd-44fe-9d45-e189b627d95e",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // Use sessionStorage (clears on tab close)
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ["User.Read", "Directory.Read.All", "Organization.Read.All"],
  prompt: "login",
};

export const powerBiRequest = {
  scopes: ["https://analysis.windows.net/powerbi/api/.default"]
};
